'use client';

import { useState } from 'react';

import { Box, Container } from '@mui/material';

import { CustomerElearning } from 'src/sections/landing/components/customer-elearning';
import { CenterRegisterForm } from 'src/sections/landing/components/center-register-form';
import { TestimonialElearning } from 'src/sections/landing/components/testimonial-elearning';

import { IntroSessionTracking } from '../components/intro-session-tracking';
import { DetailSessionTrackingFunction } from '../components/detail-session-tracking-function';
import { StartWithCenterUpSessionTracking } from '../components/start-with-center-up-session-tracking';

export const SessionTrackingView = () => {
  const [openDemo, setOpenDemo] = useState<boolean>(false);
  return (
    <Box sx={{ overflowX: 'hidden', width: 1 }}>
      <Container>
        <IntroSessionTracking setOpenDemoForm={() => setOpenDemo(true)} />
        <CustomerElearning />
        <DetailSessionTrackingFunction />
      </Container>
      <TestimonialElearning />
      <Container>
        <StartWithCenterUpSessionTracking setOpenDemoForm={() => setOpenDemo(true)} />
      </Container>
      {openDemo && <CenterRegisterForm open={openDemo} onClose={() => setOpenDemo(false)} />}
    </Box>
  );
};
